// Module
var code = `{{#results}}
<div class="result dk-col-small-shrink" data-md-id="{{id}}" data-search-type="{{searchType}}">
   <button class="content-wrap">{{value}}{{#searchType}}<i class="icon icon-schliessen"></i>{{/searchType}}</button>
</div>
{{/results}}
`;
// Exports
module.exports = code;